export const ROLES = {
  SUPERADMIN: "SUPERADMIN",
  DOCTOR: "DOCTOR",
} as const;

export type RoleType = typeof ROLES[keyof typeof ROLES];
